import React from 'react'
import { Grid, Typography } from '@material-ui/core'

import { Modal } from 'components'
import { ReactComponent as CheckLogo } from 'assets/icons/check.svg'

import { useStyles } from './styles'

interface PosModalProps {
  open: boolean
  onClose: () => void
}

const PosModal: React.FC<PosModalProps> = ({ open, onClose }) => {
  const classes = useStyles()
  return (
    <Modal open={open} onClose={onClose}>
      <Grid container direction="column" spacing={1}>
        <Grid item container justify="center" alignContent="center">
          <CheckLogo width={50} height={50} className={classes.logo} />
        </Grid>
        <Grid item>
          <Typography className={classes.modalTitle}>Ahora, a cargarlo en el POS!</Typography>
        </Grid>
      </Grid>
    </Modal>
  )
}

export { PosModal }
